import { has } from 'lodash';

import actions from 'state/constants';
import DataDogLogs from 'utils/DataDogLogs';

const activateExperimentReducer = (state, action) => {
  const { payload } = action;
  const { experimentIdentifier, options } = payload;
  const isAvailableExperiment = has(state, experimentIdentifier);
  const experimentOptions = options || {};

  if (!isAvailableExperiment) {
    DataDogLogs.error(
      `experiments:${experimentIdentifier} failed to activate! Experiment is not available.`
    );

    return state;
  }
  return {
    ...state,
    [experimentIdentifier]: {
      isActive: true,
      options: experimentOptions,
    },
  };
};

export const reducer = (state = {}, action) => {
  switch (action.type) {
    case actions.ACTIVATE_EXPERIMENT:
      return activateExperimentReducer(state, action);
    default:
      return state;
  }
};

export default reducer;
